import { useQuery } from "@tanstack/react-query";

import { GraphQLAPI, queries } from "@examspark/api";
import { LaunchToken } from "@examspark/types";

export const useQueryGetLaunchToken = (id: string | undefined | null) => {
  return useQuery({
    queryKey: ["launch-token", id],
    enabled: !!id,
    queryFn: async () => {
      const result = (
        (await GraphQLAPI.query({
          query: queries.launch.getLaunchToken(),
          variables: {
            input: {
              id: id,
              sk: "launch-token",
            },
          },
          auth: "API_KEY",
        })) as any
      ).data.getLaunchToken;

      return result as LaunchToken;
    },
  });
};
